import React from 'react'
import { CButton, CModal, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'

const DeleteModal = ({ openModal, title, confirmButtonText, onCancel, onConfirm }) => {
  return (
    <CModal visible={openModal} alignment="center">
      <CModalHeader className="border-0 px-3">
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalFooter className="border-0 px-3">
        <CButton
          style={{ color: 'black', border: '1px solid black', fontSize: '.9vw' }}
          className="mx-4 bg-white rounded-1 btn-focus-none px-4"
          onClick={onCancel}
        >
          Cancel
        </CButton>
        <CButton
          style={{ border: '1px solid black', fontSize: '.9vw' }}
          className=" bg-black rounded-1 btn-focus-none px-4"
          onClick={onConfirm}
        >
          {confirmButtonText}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default DeleteModal
